import React, { createContext, useContext, useEffect, useState } from 'react';
import { findLetterFromName, getCookies, getSocketConnected, setCookies } from '../utils/Helpers';
import APIServices from '../services/APIServices';
import { useStore } from '../hooks/useStore';

export const AuthContext = createContext();
const user2 = ['admin', 'user'];
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(getCookies('authToken'));
  const [store, setStore] = useStore();
  const [user, setUser] = useState(false);
  const [isUser1, setUser1] = useState(true);
  const [isOwner, setOwner] = useState(false);
  const [inviterId, setInviterId] = useState('');
  const [userRole, setUserRole] = useState('');
  const [customerId, setCostumerId] = useState('');
  const [socket, setSocket] = useState(null);
  const [userCompany, setUserCompany] = useState('');
  const [subInfo, setSubInfo] = useState(null);
  const [isUpdating, setUpdating] = useState(false);
  const [userShortName, setUserShortName] = useState(false);
  const [isDark, setIsDark] = useState(true);

  const fetchUserInfo = async () => {
    if (!token) return;

    try {
      const userRes = await APIServices.get(`/user/detail?token=${token}`);
      let userRole;
      if (!userRes) return [];

      if (userRes.status === 404) {
        logout();
        return;
      }

      const userData = userRes.data;
      setUser(userData);
      setInviterId(userData?._id);
      if (userData.companyId) {
        setUserCompany(userData.companyId);
      }
      if (userData.fullName) {
        let latters = findLetterFromName(userData.fullName);
        setUserShortName(latters);
      }
      if (userData?.settings?.dateTimeFormat) {
        const { dateFormat, timeFormat, startCalenderWeek } = userData.settings.dateTimeFormat;
        setStore({
          currentDateFormat: dateFormat,
          currentTimeFormat: timeFormat,
          startCalenderWeek
        });
      }
      if (userData?.organizations[0]) {
        userRole = userData?.organizations[0].userType.role;
      } else {
        userRole = userData?.userType?.role;
      }

      // if (userData?.userSubscription) {
      // console.log(userData?.userSubscription?.subscriptions?.[0]);

      setSubInfo(userData?.userSubscription?.subscriptions?.[0]); /////
      setCostumerId(userData?.userSubscription?.stripeCustomerId || userData?.userSubscription?.chargebeeCustomerId || '');
      // }
      // if (userData?.subscriptionPlan) {
      //   setSubInfo(userData?.subscriptionPlan); ////
      // }
      // console.log(userRole);
      setUserRole(userRole);

      if (user2.includes(userRole)) {
        setUser1(false);
      }
      if (userRole === 'owner') {
        setOwner(true);
      } else {
        setOwner(false);
      }
      if (userData?.appTheme === 'dark') {
        setIsDark(true);
        document.body.classList.add('dark_theme');
        localStorage.setItem('theme', 'dark');
      } else {
        setIsDark(false);
        localStorage.setItem('theme', 'light');
        document.body.classList.remove('dark_theme');
      }

      return userData;
    } catch (error) {
      console.error('Error fetching user info:', error);
      return [];
    }
  };

  useEffect(() => {
    if (user && !socket) {
      let newSocket = getSocketConnected(user._id);
      setSocket(newSocket);

      // Listen for connection status
      newSocket.on('connect', () => {
        console.log('Socket connected');
      });

      newSocket.on('disconnect', () => {
        console.log('Socket disconnected');
      });
      // // Clean up the socket connection when component unmounts
      // return () => {
      //   newSocket.disconnect();
      // };
    }
  }, [user]);

  useEffect(() => {
    if (!token) return;
    fetchUserInfo();
  }, [token]);

  const logout = () => {
    setUser(null);
    setCookies('authToken', null);
    refreshToken('');
    setUser1(true);
    setSubInfo(null);
    setSocket(null);
    localStorage.setItem('isUpdatingPlan', false);
  };

  // If user logoff or login, update token from child component
  const refreshToken = (newToken) => {
    setToken(newToken);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        refreshToken,
        logout,
        token,
        fetchUserInfo,
        inviterId,
        isUser1,
        userRole,
        socket,
        userCompany,
        customerId,
        subInfo,
        isUpdating,
        isOwner,
        userShortName
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
